import React from "react";
import { ParagraphMomento } from "@tumomento/ui";
import "./ContentTable.scss";

export type ContentTableProps = {
  subtitles: string[];
};
export const ContentTable = ({ subtitles }: ContentTableProps) => {
  return subtitles.length > 0 ? (
    <div className="flex col g-6 momento-blog-content-table">
      <ParagraphMomento typography="heading-m" color="green2">
        Tabla de Contenido
      </ParagraphMomento>
      <ul className="flex col g-1 mb-4">
        {subtitles.map((s, i) => (
          <li key={`subtitle-${i}-${s}`}>
            <a className="momento-text heading-s green3" href={`#${s}`}>
              {s}
            </a>
          </li>
        ))}
      </ul>
    </div>
  ) : null;
};
